import {
  FOLLOWUPLIST_LOADING,
  GET_FOLLOWUPLIST,
  GET_FOLLOWUPLIST_SUCCESS,
  GET_FOLLOWUPLIST_FAIL,
  ADD_FOLLOWUPLIST_SUCCESS,
  ADD_FOLLOWUPLIST_FAIL,
  DELETE_FOLLOWUPLIST_SUCCESS,
  DELETE_FOLLOWUPLIST_FAIL,
  UPDATE_FOLLOWUPLIST_SUCCESS,
  UPDATE_FOLLOWUPLIST_FAIL,
  FOLLOWUPLIST_RESET
} from "./actionType";

const INIT_STATE = {
  followupLists: [],
  error: {},
};

const FollowupList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FOLLOWUPLIST_SUCCESS:
      switch (action.payload.actionType) {
        case GET_FOLLOWUPLIST:
          return {
            ...state,
            followupLists: action.payload.data,
            isFollowupListCreated: false,
            isFollowupListSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_FOLLOWUPLIST_FAIL:
      switch (action.payload.actionType) {
        case GET_FOLLOWUPLIST_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isFollowupListCreated: false,
            isFollowupListSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_FOLLOWUPLIST: {
      return {
        ...state,
        isFollowupListCreated: false,
        loading: true,
      };
    }

    case FOLLOWUPLIST_LOADING: {
      return {
        ...state,
        isFollowupListCreated: false,
        loading: true,
      };
    }

    case ADD_FOLLOWUPLIST_SUCCESS:
      return {
        ...state,
        isFollowupListCreated: true,
        loading: false,
        followupLists: [action.payload.data, ...state.followupLists],
      };

    case ADD_FOLLOWUPLIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_FOLLOWUPLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        followupLists: state.followupLists.filter(
          civilFollowupList => civilFollowupList.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_FOLLOWUPLIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_FOLLOWUPLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        followupLists: state.followupLists.map(civilFollowupList =>
          civilFollowupList.id.toString() === action.payload.data.id.toString() ? { ...civilFollowupList, ...action.payload.data } : civilFollowupList
        ),
      };

    case UPDATE_FOLLOWUPLIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FOLLOWUPLIST_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default FollowupList;